import React, { useState } from 'react';
import { Menu, Layout } from "antd";
import MasterLayout from "../MasterLayout";
import EpisodeManager from "../EpisodeManager";
import BucketPullsContent from "./producer/BucketPullsContent";
import { useEpisode } from "../../contexts/EpisodeContext";
import ScreenControl from "./producer/ScreenControl";
import WebSocketConnection from "./screen/WebSocketConnection";

const { Sider } = Layout;

const Producer = () => {
    const { episode } = useEpisode();
    const [activeMenuItem, setActiveMenuItem] = useState('bucket-pulls');
    const [screenContent, setScreenContent] = useState('--');

    const handleMenuClick = e => {
        setActiveMenuItem(e.key);
    };

    const handleScreenUpdate = (payload) => {
        let content = '';
        switch (payload.type) {
            case 'Standby':
                content = 'Standby';
                break;
            case 'showStart':
                content = 'Show Start';
                break;
            case 'showEnd':
                content = 'Show End';
                break;
            case 'customMessage':
                content = `Custom Message: ${payload.message}`;
                break;
            case 'bucketPull':
                content = `Bucket Pull: ${payload.entry.paperName}`;
                break;
            default:
                content = 'Unknown update';
        }
        setScreenContent(content);
    };

    const menuContent = (
        <Sider width={200} theme="dark" style={{ background: '#000', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={['bucket-pulls']}
                style={{
                    borderRight: 0,
                    background: '#000',
                    flex: 1,
                    overflowY: 'auto',
                    fontWeight: 'bold'
                }}
                onClick={handleMenuClick}
            >
                <Menu.Item key="bucket-pulls">Bucket Pulls</Menu.Item>
                <Menu.Item key="screen-control">Screen Control</Menu.Item>
            </Menu>
            {/* Content container for websocket updates */}
            <div style={{
                padding: '16px',
                borderTop: '1px solid #333',
                color: '#fff',
                fontSize: '14px',
                background: '#000',
                minHeight: '120px', // Minimum height
                maxHeight: '50%', // Maximum height (adjust as needed)
                overflow: 'hidden',
                wordWrap: 'break-word',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <h4 style={{ color: '#fff', marginBottom: '8px', flexShrink: 0 }}>Screen Displaying:</h4>
                <div style={{ flexGrow: 1 }}>{screenContent}</div>
            </div>
        </Sider>
    );

    return (
        <MasterLayout sider={menuContent}>
            <EpisodeManager />
            <WebSocketConnection setPayload={handleScreenUpdate} />
            {activeMenuItem === 'bucket-pulls' && <BucketPullsContent episodeId={episode?.id} />}
            {activeMenuItem === 'screen-control' && <ScreenControl />}
        </MasterLayout>
    );
};

export default Producer;